import { mergeElementData } from '@99designs/common/utils/jquery';
import RangeSlider from './range-slider-lib';

var pluginName = 'rangeslider',
    defaults = {
        type: 'single',
        step: 0,
        min: 0,
        max: 10,
        maxlabel: 'Min',
        minlabel: 'Max',
        labelprefix: '',
        disabled: false,
        stepmin: 20,
    };

var build = function (options, elem) {
    var obj = new RangeSlider().init(options, elem);

    // Public API

    return {
        moveTo: function (index, val) {
            obj.setHandle(index, val);
        },
    };
};

// Plugin definition

$.fn[pluginName] = function (options) {
    return this.each(function () {
        if (!$.data(this, pluginName)) {
            var opts = mergeElementData($(this), pluginName, $.extend(true, {}, defaults, options));

            $.data(this, pluginName, build(opts, this));
        }
    });
};



// WEBPACK FOOTER //
// ./src/web/js/app/modules/range-slider.js